<template>
    <div>
        <div class="columns">
            <div class="column is-6">
                <div class="control has-icons-left">
                    <input v-model="search" class="input" type="text" placeholder="Search...">
                    <span class="icon is-small is-left">
                        <i class="fa fa-search"></i>
                    </span>            
                </div>
            </div>
        </div>

        <table class="table is-hoverable is-bordered is-fullwidth">
            <thead>
                <tr>
                    <th v-for='col in columns' class="sortable" @click='sortBy(col.key)'>
                        {{col.name}} 
                        <i class="fa fa-sort-up is-pulled-right" v-if="column == col.key && reverse"></i>
                        <i class="fa fa-sort-down  is-pulled-right" v-if="column == col.key && !reverse"></i>
                    </th>
                    <th v-if="pivot">Seen</th>
                    <th v-if="actions">Actions</th>        
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in items" @click="show(item.id)">
                    <td>{{item.id}}</td>
                    <td>{{item.title}}</td>
                    <td>{{item.description}}</td>
                    <td>{{item.type}}</td>
                    <td class="has-text-centered" v-if="item.pivot && pivot && item.pivot.seen !== undefined">
                        <i class="fa fa-check has-text-success" v-if="item.pivot.seen == true"></i>
                        <i class="fa fa-times has-text-danger" v-else></i>
                    </td>
                    <td v-if="actions" width="10%">
                        <router-link v-bind:to="{ name: 'news', params: { id: item.id }}" class="button tooltip" data-tooltip="View">
                            <span class="icon">
                                <i class="fa fa-eye"></i>
                            </span>
                        </router-link>

                        <router-link @click.native.stop="" v-bind:to="{ name: 'news-edit', params: { id: item.id }}" class="button is-warning tooltip" data-tooltip="Edit">
                            <span class="icon">
                                <i class="fa fa-edit"></i>
                            </span>
                        </router-link>

                        <button class="button is-danger tooltip" data-tooltip="Delete" @click="showDeleteModal($event, item.id, index)">
                            <span class="icon">
                                <i class="fa fa-trash"></i>
                            </span>
                        </button>                                
                    </td>
                </tr>
            </tbody>
        </table>
        <bulma-pagination :current="page" @change="onPageChanged" :last="total"></bulma-pagination>
    </div>
</template>

<script>
import NewsRepo from '../../repos/NewsRepo'
import lodash from 'lodash'

export default {
  name: 'news-table',
  props: {
	items: { required: true },
    page: { required: true },
    total: { required: false, default: 0 },
    actions: {required: false, default: false},
    pivot: {required: false, default: false}
  },
  components: {},
  data() {
        return {
            search: '',
            column: 'id',
            columns: [
                {
                    name: '#',
                    key: 'id'
                },
                {
                    name: 'Title',
                    key: 'title'
                },
                {
                    name: 'Description',
                    key: 'description'
                },
                {
                    name: 'Type',
                    key: 'type'
                }
            ],
            reverse: true,
            repo: new NewsRepo(this.$auth),
        }
  },
  created(){        
  },
  methods: {
    sortBy(column) {    
    
        if(column != ''){
            if(this.column == column){
              this.reverse = !this.reverse;
            }
            else{
              this.column = column;
            }

            let direction = this.reverse ? "asc" : "desc";

            this.$emit("sort", this.column + "," + direction);
        }
    },   
    onPageChanged(page){
        this.$emit("pageChanged", page);
    },    
    show(id){
        this.$router.push('/dashboard/news/' + id);
    },
    showDeleteModal(event, id, index){
        event.stopPropagation();
        let self = this;
        this.$swal({
            title: 'Are you sure?',
            text: "This will delete this news permanently!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3273dc',
            cancelButtonColor: '#ff3860',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.value) {
                self.deleteNews(id, index);
            }
        }).catch((result) => {
        });

    },
    deleteNews (id, index) {
        this.repo.delete(id).then(response => {  
            this.items.splice(index, 1);
            this.$swal(
                'Deleted!',
                'News has been deleted.',
                'success'
            )
        });
    }
  },
  watch: {
      'search': _.debounce(function(value){
        this.$emit("search", value);
      }, 800) 
  },
  computed: {
  }  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/news/Table.vue